import { createSlice } from "@reduxjs/toolkit";
import {createDeposit, getDeposit} from "./DepositActions"

const initialState = {
    loading: false,
    deposit: {},
    error: null,
    success: false, // for monitoring the registration process.
  }

const DepositSlice = createSlice({
    name: "DepositSlice",
    initialState,
    reducers: {},
    extraReducers:{
        [createDeposit.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.deposit = payload.data
        },
        [createDeposit.pending]: (state, {payload}) => {
            state.loading = true
        },
        [createDeposit.rejected]: (state, {payload}) => {
            state.loading = false
            state.deposit = payload
        },
        [getDeposit.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.deposit = payload.data
        },
        [getDeposit.pending]: (state, {payload}) => {
            state.loading = true
        },
        [getDeposit.rejected]: (state, {payload}) => {
            state.loading = false
            state.deposit = payload
        }
    }
})

export default DepositSlice.reducer